import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateDishForm } from '@/features/dish'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/canteen/menu-settings/dishes/create')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создание блюда')}>
      <CreateDishForm onClose={close} />
    </Offcanvas>
  )
}
